module.exports = __webpack_public_path__ + "static/media/createitens.0401c6c4.svg";